<template>
  <div v-if="shouldShowAlert && !isDismissed">
    <b-alert 
      variant="danger" 
      class="mt-2" 
      show
      dismissible
      @dismissed="handleDismiss"
    >
      {{ $t('pages.profile.sms.usage.threshold.error.message') }}
      <b-button style="padding:0;margin:0;" variant="link" @click="$router.push({ name: 'sms' })"><strong>
        {{ $t('pages.profile.sms.usage.threshold.cta') }}</strong></b-button>
    </b-alert>
  </div>
</template>

<script>
import { mapState } from "vuex";

const DISMISSAL_KEY = 'sms-threshold-alert-dismissed';

export default {
  computed: {
    ...mapState({
      userSmsSettings: (state) => state.auth.userSmsSettings,
    }),

    usedOrPlannedForPeriod() {
      return (
        this.userSmsSettings?.usage?.used_sms +
        this.userSmsSettings?.usage?.scheduledForPeriod
      );
    },

    isOverThreshold() {
      // Only show alert when used/planned exceeds the max SMS threshold
      return this.usedOrPlannedForPeriod >= this.userSmsSettings?.maxSms;
    },

    shouldShowAlert() {
      // Only show alert if we have SMS settings and exceed the threshold
      if (!this.userSmsSettings?.maxSms) return false;
      return this.isOverThreshold;
    },
  },
  data() {
    return {
      isDismissed: false,
    };
  },
  mounted() {
    this.checkDismissedState();
  },
  watch: {
    shouldShowAlert(newVal) {
      // Check dismissed state when alert condition changes
      if (newVal) {
        this.checkDismissedState();
      }
    },
  },
  methods: {
    checkDismissedState() {
      // Check if alert was dismissed in this session
      const dismissed = sessionStorage.getItem(DISMISSAL_KEY);
      this.isDismissed = dismissed === 'true';
    },
    handleDismiss() {
      // Save dismissal to sessionStorage
      this.isDismissed = true;
      sessionStorage.setItem(DISMISSAL_KEY, 'true');
    },
  },
};
</script>
